(function () {
    'use strict';

    angular
        .module('harriApp')
        .service('recruitmentHubService', recruitmentHubService);

    recruitmentHubService.$inject = ['$q', '$filter', '$modal', 'brandServices', 'backgroundChecksService', 'spreadTheWordModalService'];


    function recruitmentHubService($q, $filter, $modal, brandServices, backgroundChecksService, spreadTheWordModalService) {
        var self = this;

        self.showAddApplicantModal = function (fromApplicant, job= null) {
            var defer = $q.defer();

            $modal({
                controller: 'UploadApplicantModal',
                templateUrl: '../modules/upload_applicants/modals/upload_applicant/upload_applicant_modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            fromApplicant: fromApplicant,
                            job: job,
                            onSuccess: function () {
                                defer.resolve('SUCCESS');
                            }
                        };
                    }
                }
            });
            return defer.promise;
        };

        self.showPrintModal = function (applications) {
            var preparedApplicants = prepareApplicantsForPrint(applications);
            $modal({
                controller: 'PrintSpeedyScreenModalController',
                controllerAs: '$ctrl',
                templateUrl: '../modules/speedy_screen/modals/print-speedy-screen/print-speedy-screen.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            applications: preparedApplicants
                        };
                    }
                }
            });
        };

        var prepareApplicantsForPrint = function (applications) {
            var preparedApplicants = [];
            for (var i in applications) {
                var application = {
                    application_id: applications[i].application.id,
                    user_id: applications[i].user.id,
                    job_id: applications[i].job.id,
                    brand_id: applications[i].brand.id,
                    candidate: {
                        first_name: applications[i].user.firstName,
                        last_name: applications[i].user.lastName
                    }
                };
                preparedApplicants.push(application);
            }
            return preparedApplicants;
        };

        self.showInterviewInviteModal = function (modalData) {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'InterviewInviteModalController',
                    templateUrl: '../modules/interview-v2/interview-invite/interview_invite_modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return modalData;
                        },
                        onHide: function () {
                            return function () {
                                resolve();
                            };
                        },
                        onSave: function () {
                            return function () {
                                resolve();
                            };
                        }
                    }
                });
            });
        };

        self.showMoveToSkipModal = function (applications) {
            var defer = $q.defer();
            prepareModalDataForSkip(applications)
                .then(function (preparedModalData) {
                    var applicationsToMove = [];
                    for (var i in applications) {
                        applicationsToMove.push({
                            app_id: applications[i].application.id,
                            index: parseInt(i)
                        });
                    }

                    var indexArray = applicationsToMove.map(function(item) {
                        return parseInt(item.index);
                    });
                    var toState = {
                        bucket: "Passed",
                        indices: indexArray,
                        location: "all"
                    }

                    if ((preparedModalData.brandSkipReasons && preparedModalData.brandSkipReasons.reasons.length) || preparedModalData.rejectionTemplates) {
                        if (preparedModalData.brandSkipReasons && !preparedModalData.brandSkipReasons.reasons.length && preparedModalData.brandSkipReasons.is_usage_required) {
                            hAlert({
                                title: $filter("translate")("Restricted"),
                                text: $filter("translate")("To ensure each candidate is skipped with a reason, please define reasons for every stage."),
                                custom_class: 'rejection-templates-error-alert'
                            });
                        } else {
                            $modal({
                                controller: 'SkipModalController',
                                templateUrl: '../modules/ams/modals/skip_reasons/skip.html',
                                show: true,
                                backdrop: 'static',
                                resolve: {
                                    modalData: function () {
                                        return preparedModalData;
                                    },
                                    onSendToSkip: function () {
                                        return function () {
                                            AMSAPI.moveCards(applications[0].job.id, [applicationsToMove], toState)
                                                .then(function (res) {
                                                    defer.resolve("SEND_TO_SKIP");
                                                }).catch(function () {
                                                hAlert({
                                                    title: $filter("translate")("Error"),
                                                    text: "Something went wrong.",
                                                    custom_class: 'rejection-templates-error-alert',
                                                });
                                            })
                                        };
                                    },
                                    onHide: function () {
                                        return function () {
                                            defer.resolve("ON_HIDE")
                                        };
                                    },
                                    onError: function () {
                                        return function () {
                                        }
                                    }
                                }
                            });
                        }

                    } else {
                        AMSAPI.moveCards(applications[0].job.id, [applicationsToMove], toState)
                            .then(function (res) {
                                defer.resolve("SEND_TO_SKIP");
                            }).catch(function () {
                            hAlert({
                                title: $filter("translate")("Error"),
                                text: "Something went wrong.",
                                custom_class: 'rejection-templates-error-alert',
                            });
                        })
                    }

                })
            return defer.promise;
        };

        self.showMoveToJobModal = function (applications) {
            var defer = $q.defer();
            prepareMoveToJobModalData(applications)
                .then(function (preparedModalData) {
                    $modal({
                        controller: 'moveToJobController',
                        templateUrl: '../modules/ams/modals/move_to_job_modal/move_to_job_modal.html',
                        show: true,
                        backdrop: 'static',
                        resolve: {
                            modalData: function () {
                                return preparedModalData;
                            },
                            success: function () {
                                return function (passedAppIds, job, brand, failed, duplicate) {
                                    if (passedAppIds && passedAppIds.length) {
                                        var passedCandidates = [];
                                        for (var i in applications) {
                                            if (passedAppIds.indexOf(parseInt(applications[i].application.id)) > -1) {
                                                passedCandidates.push({
                                                    'application_id': applications[i].application.id,
                                                    'name': applications[i].user.first_name + ' ' + applications[i].user.last_name
                                                })
                                            }
                                        }

                                        var candidatesNames = "";
                                        if (passedCandidates) {
                                            if (Object.keys(passedCandidates).length > 1 ) {
                                                candidatesNames = Object.keys(passedCandidates).length + " candidates";
                                            }
                                            else {
                                                candidatesNames = passedCandidates[0].name;
                                            }
                                        }

                                        if (!failed || _.isEmpty(failed)) {
                                            var message = candidatesNames + " has been successfully " + (duplicate ? "duplicated" : "moved") +
                                                " to " + brand.name + " - " + job.position.name;

                                            hConfirm({
                                                title: $filter('translate')('Move to another job'),
                                                text: message,
                                                confirmButton: $filter('translate')('Okay'),
                                                callback: function () {
                                                    defer.resolve('MOVED_TO_JOB');
                                                }
                                            });
                                        }
                                    }
                                }
                            },
                            failure: function() {
                                return function(reason) {
                                    defer.reject(reason);
                                }
                            }
                        }
                    });
                })
                .catch(function (error) {
                    console.error(error);
                });

            return defer.promise;
        }

        self.showArchiveModal = function (modalData) {
            var defer = $q.defer();

            $modal({
                controller: 'SkipModalController',
                templateUrl: '../modules/ams/modals/skip_reasons/skip.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return modalData;
                    },
                    onSendToSkip: function () {
                        return function () {
                            defer.resolve("ON_ARCHIVE");
                        };
                    },
                    onHide: function () {
                        return function () {
                            defer.resolve("ON_HIDE");
                        };
                    },
                    onError: function () {
                        return function () {
                        };
                    }
                }
            });
            return defer.promise;
        };

        self.showATRModal = function (job) {
            var defer = $q.defer();
            $modal({
                controller: 'unArchiveATRController',
                templateUrl: '../modules/dashboard/views/partials/unarchive_atr_modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            body: $filter("translate")("Applied ATRs for this job post"),
                            job: job,
                            brandId: job.brand.id
                        };
                    },
                    onSuccess: function () {
                        return function (atr_ids) {
                            if (atr_ids) {
                                defer.resolve('SUCCESS');
                            }
                        };
                    },
                }
            });
            return defer.promise;
        }

        self.showAuditTrailModal = function (job) {
            var positionSlug = $filter('userPosition')({'Position': job.position, 'custom_position': job.alias_position});

            var modalData = {
                brand: {id: job.brand.id},
                jobId: job.id,
                positionSlug: positionSlug
            };

            $modal({
                controller: 'jobAuditTrailModalController',
                controllerAs: "$ctrl",
                templateUrl: '../modules/job_create/modals/job-audit-trail/job-audit-trail.modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return modalData;
                    },
                    onSuccess: function () {
                    },
                    onError: function () {
                    }
                }
            });
        }

        self.showJobDistributorStatusModal = function (job) {
            $modal({
                controller: 'jobDistributorStatusController',
                templateUrl: '../modules/dashboard/views/partials/job-distributor-status-modal.html',
                show: true,
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            'brandId': job.brand.id,
                            'jobId': job.id
                        };
                    },
                    onClose: function () {
                    },
                    onRetry: function() {
                    }
                }
            });
        }

        self.showJobApprovalStatusModal = function (job) {
            $modal({
                controller: 'jobStatusDetailsController',
                templateUrl: '../hmodules/job-approval/modals/job-status-details/job-status-details.modal.html',
                show: true,
                controllerAs: "$ctrl",
                backdrop: 'static',
                resolve: {
                    modalData: function () {
                        return {
                            brandId: job.brand.id,
                            jobId: job.id,
                        };
                    }
                }
            });
        }

        self.showJobAssigneesActionsModal = function (modalData) {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'JobAssigneesActionsModalController',
                    templateUrl: '../modules/hmap/my_jobs/job_assignees_actions_modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return modalData;
                        },
                        onHide: function () {
                            return function () {
                                resolve();
                            };
                        },
                        onSave: function () {
                            return function () {
                                resolve();
                            };
                        }
                    }
                });
            });
        };

        self.showBoostJobModal = function (jobId, brandId, privateJobKey, jobs, jobsGroupedByService) {
            spreadTheWordModalService.init(brandId, null, jobId, "BOOST", privateJobKey, jobs, jobsGroupedByService);
            spreadTheWordModalService.show();
        };

        self.showSmartMatchCandidatesModal = (job) => {
            $modal({
                controller: 'smartMatchCandidatesModalController',
                templateUrl: '../modules/dashboard/modals/smart-match-candidates/smart-match-candidates.modal.html',
                show: true,
                controllerAs: "$ctrl",
                backdrop: 'static',
                resolve: {
                    modalData: () => {
                        return {
                            brandId: job?.brand?.id,
                            job: job,
                        };
                    },
                }
            });
        }

        self.showManageAssigneesModal = function (job) {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'jobManageAssigneesController',
                    templateUrl: './modules/dashboard/modals/job_manage_assignees_modal/job_manage_assignees_modal.html',
                    show: true,
                    controllerAs: 'form',
                    backdrop: 'static',
                    resolve: {
                        job: function () {
                            return {
                                'assignees': job.assignees,
                                'jobId': job.id,
                                'brandId': job.brand.id,
                                'position': job.position,
                                'jobPostType': job.post_type || job.access_mode
                            };
                        },
                        onSave: function () {
                            return function (assignees) {
                                resolve();
                            }
                        }
                    }
                });
            });
        };

        self.showEmailVerificationModal = function () {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'EmailVerificationModal',
                    templateUrl: '../hmodules/user-activation/modals/email-verification/email-verification.modal.html',
                    show: true,
                    backdrop: 'static',
                    controllerAs: '$ctrl',
                    resolve: {
                        onSave: function () {
                            return function () {
                                resolve();
                            }
                        },
                        onClose: function () {
                            return function () {
                            };
                        }
                    }
                });
            });
        };

        self.showInterviewTemplatesModal = function (interviewSet, evaluationType, preStarted) {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'StartInterviewEvaluationModal',
                    controllerAs: 'startInterviewEvaluationModal',
                    templateUrl: '../hmodules/interview-bank/modals/start-interview/start-interview-evaluation.modal.html',
                    show: true,
                    backdrop: 'static',
                    resolve: {
                        modalData: function () {
                            return {
                                brandId: interviewSet.job.brand.id,
                                applicationId: interviewSet.application_id,
                                jobId: interviewSet.job.id,
                                evaluationType: evaluationType,
                                positionName: interviewSet.job.alias_position || interviewSet.job.position.name,
                                positionCode: interviewSet.job.position.code,
                                preStarted: preStarted
                            }
                        },
                        startEvaluation: function () {
                            return function (evaluationId) {
                                resolve(evaluationId);
                            }
                        },
                        viewInterviewQuestions: () => {
                            return () => {};
                        }
                    }
                });
            });
        };

        self.showOpenDayDetailsModal = function (modalData) {
            return new Promise((resolve, reject) => {
                $modal({
                    controller: 'OpenDayDetailsModalController',
                    templateUrl: '../modules/hforms/openday_details/views/open_day_details_modal.html',
                    show: true,
                    resolve: {
                        modalData: function () {
                            return modalData;
                        },
                        onHide: function () {
                            return function () {
                                resolve();
                            };
                        },
                        onSave: function () {
                            return function () {
                                resolve();
                            };
                        }
                    }
                });
            });
        };

        var getBrandRejectionTemplatesAndSkipReasons = function (brandId) {
            var defer = $q.defer();
            var promises = {
                isRejectionTemplates: brandServices.check(brandServices.SERVICES.REJECTION_TEMPLATES, brandId),
                isReasonToSkipServiceEnabled: brandServices.check(brandServices.SERVICES.REASON_TO_SKIP, brandId)
            }
            $q.all(promises)
                .then(function (data) {
                    var innerPromises = {};
                    var rejectionTemplates = {};
                    if (data.isRejectionTemplates) {
                        innerPromises['rejectionTemplates'] = BrandAPI.getBrandRejectionTemplates(brandId, 'ALL');
                    }

                    if (data.isReasonToSkipServiceEnabled) {
                        innerPromises['skip_reasons'] = BrandAPI.getBrandSkipReasons(brandId);
                    }
                    $q.all(innerPromises)
                        .then(function (result) {
                                if (result.rejectionTemplates) {
                                    var templates = result.rejectionTemplates.message_templates;
                                    for (var i in templates) {
                                        var template = templates[i];
                                        template.updated = new Date(template.updated);
                                        rejectionTemplates[template.id] = template;
                                    }
                                    result.rejectionTemplates.message_templates = rejectionTemplates
                                }

                                if (result.skip_reasons) {
                                    var brandSkipReasons = result.skip_reasons;
                                }
                                defer.resolve({
                                    rejectionTemplates: result.rejectionTemplates,
                                    brandSkipReasons: brandSkipReasons
                                });

                                if (!result.message_templates && !result.skip_reasons) {
                                    defer.resolve();
                                }
                            },
                            function () {
                                defer.reject();
                            })

                }, function () {
                    defer.reject();
                });

            return defer.promise;
        }

        var prepareMoveToJobModalData = function (applications) {
            var defer = $q.defer();

            backgroundChecksService.getSettings(applications[0].brand.id)
                .then(function (backgroundCheckSettings) {
                    var appIds = [];
                    var candidatesDetails = {}
                    for (var i in applications) {
                        //prepare appIds attribute
                        appIds.push({
                            'app_id': applications[i].application.id,
                            'index': parseInt(i)
                        });

                        //prepare candidatesDetails attribute
                        candidatesDetails[applications[i].application.id] = {
                            index: parseInt(i),
                            data: {
                                'application_id': applications[i].application.id,
                                'firstName': applications[i].user.first_name,
                                'lastName': applications[i].user.last_name,
                                'name': applications[i].user.first_name + ' ' + applications[i].user.last_name
                            }
                        };
                    }

                    var statesIndices = appIds.map(function(item) {
                        return parseInt(item.index);
                    });

                    //prepare fromStates attribute
                    var fromStates = {
                        'bucket': applications[0].application.current_bucket.code,
                        'indices': statesIndices,
                        'location': "all"
                    }

                    //prepare toState attribute
                    var toState = {
                        'indices': statesIndices
                    }

                    var applicationsDetails = {
                        'appIds': [appIds],
                        'fromStates': [fromStates],
                        'toState': toState
                    };

                    //prepare job attribute
                    var applicantsJob = applications[0].job;
                    applicantsJob.Brand = applications[0].brand;

                    defer.resolve({
                        applications: applicationsDetails,
                        job: applicantsJob,
                        backgroundCheckSettings: backgroundCheckSettings,
                        candidatesDetails: candidatesDetails
                    });
                })
                .catch(function (error) {
                    defer.reject(error);
                });
            return defer.promise;
        }

        var prepareModalDataForSkip = function (applications) {
            var defer = $q.defer();
            var brandId = applications[0].brand.id;
            getBrandRejectionTemplatesAndSkipReasons(brandId)
                .then(function (data) {
                    var filteredArchiveReasons = {};
                    for (var reason in OnBoardingAPI.ARCHIVE_REASONS) {
                        if (OnBoardingAPI.ARCHIVE_REASONS.hasOwnProperty(reason)) {
                            if (reason !== 'POSITION_CHANGE') {
                                filteredArchiveReasons[reason] = OnBoardingAPI.ARCHIVE_REASONS[reason];
                            }
                        }
                    }
                    var formattedCandidates = [];
                    for (var i in applications) {
                        formattedCandidates.push({
                            'id': applications[i].user.id,
                            'name': applications[i].user.first_name + ' ' + applications[i].user.last_name,
                            'application_id': applications[i].application.id || null
                        });
                    }

                    defer.resolve({
                        brandId: applications[0].brand.id,
                        jobId: applications[0].job.id || null,
                        candidates: formattedCandidates,
                        rejectionTemplates: data.rejectionTemplates,
                        skipBucketCandidates: formattedCandidates,
                        archiveSection: false,
                        showRejectionTemplateOnly: data.brandSkipReasons && !data.brandSkipReasons.reasons.length,
                        skipReasons: ((data.brandSkipReasons && data.brandSkipReasons.reasons.length) ? data.brandSkipReasons : undefined),
                        brandSkipReasons: data.brandSkipReasons,
                        source: 'ams',
                        archiveReasons: filteredArchiveReasons,
                        prospect_id: applications[0].job.position.id
                    })
                })
            return defer.promise;
        };

        var prepareModalDataForInterviewTemplates = function (interviewSet, preStarted) {
            var defer = $q.defer();
            return {
                brandId: interviewSet.job.brand.id,
                applicationId: interviewSet.application_id,
                jobId: interviewSet.job.id,
                evaluationType: getEvaluationTypeByInterviewSet(interviewSet),
                positionName: interviewSet.job.alias_position || interviewSet.job.position.name,
                positionCode: interviewSet.job.position.code,
                preStarted: preStarted
            }
            return defer.promise;
        };
    }
})();
